import { memo } from 'react';
import { cn, RawHtml } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import useTranslation from '@Queries/useTranslation';
import FeatureItem from '../FeatureItem';
import GallerySection from '@Components/GallerySection';
import styles from './ProductFeatures.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { Feature } from '../FeatureItem';

export interface ProductFeaturesProps extends HTMLAttributes<HTMLDivElement> {
  description: string;
  features: Feature[];
}

const ProductFeatures: FC<ProductFeaturesProps> = (props) => {
  const { className, features, description, ...restProps } = props;
  const { isDesktop } = useMedias();
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {description && <RawHtml html={description} className={styles.description} />}
      {features?.length > 0 && (
        <GallerySection
          title={t('advantages')}
          slides={features}
          cnGallery={styles.gallery}
          scrollbar={isDesktop}
          renderSlide={(feature) => <FeatureItem feature={feature} />}
        />
      )}
    </div>
  );
};

export default memo(ProductFeatures);
